import type { CategoryId } from "app/common/services/categoryService.types";
import type { IServices } from "app/pages/industry-analysis/overview/components/IndustryOverviewContext/IndustryOverviewContext";
import type { RawParams } from "@uirouter/core";

export const getSingleMetricApiQueryParams = (services: IServices, allParams: RawParams) => {
    const { duration, comparedDuration, category: categoryParam, country, webSource } = allParams;
    const categoryDetails = resolveCurrentCategory(categoryParam, services);

    const durationDetails = services.durationService.getDurationData(duration, comparedDuration).forAPI;

    return {
        category: categoryDetails.forApi,
        keys: categoryDetails.forApi,
        country: country,
        webSource,
        isWindow: durationDetails.isWindow,
        includeSubDomains: true,
        timeGranularity: "Monthly",
        from: durationDetails.from,
        to: durationDetails.to,
        compareFrom: durationDetails?.compareFrom,
        compareTo: durationDetails?.compareTo,
    };
};

export const getTableApiQueryParams = (services: IServices, allParams) => {
    const { country, duration, webSource, category: categoryId, page } = allParams;

    const categoryDetails = resolveCurrentCategory(categoryId, services);
    const isCustomCategory = services.customCategoryService.isCustomCategory(categoryId);
    const durationDetails = services.durationService.getDurationData(duration).forAPI;

    return {
        category: categoryDetails.forApi,
        categoryHash: isCustomCategory ? categoryDetails.categoryHash : "",
        keys: categoryDetails.forApi,
        country: country,
        from: durationDetails.from,
        to: durationDetails.to,
        webSource: webSource,
        isWindow: durationDetails.isWindow,
        timeGranularity: "Monthly",
        includeSubDomains: true,
        pageSize: 5,
        page,
    };
};

const resolveCurrentCategory = (categoryId: CategoryId, services: IServices) => {
    return services.categoryService.categoryQueryParamToCategoryObject(categoryId);
};

const getDurationDetails = (services: IServices, params: RawParams) => {
    const { duration, comparedDuration } = params;
    return services.durationService.getDurationData(duration, comparedDuration);
};
